import React, { Dispatch, SetStateAction } from 'react';
import { Button, ButtonGroup } from '@mui/material';

import { CalendarView } from '../types';

interface Props {
  view: CalendarView;
  setView: Dispatch<SetStateAction<CalendarView>>;
}

export const CalendarViews = ({ view, setView }: Props) => {
  return (
    <ButtonGroup fullWidth>
      {[
        { key: CalendarView.Table, label: 'Agenda' },
        { key: CalendarView.Day, label: 'Day' },
        { key: CalendarView.Week, label: 'Week' },
        { key: CalendarView.Month, label: 'Month' },
      ].map(({ key, label }) => (
        <Button
          key={key}
          size="small"
          color="primary"
          onClick={() => setView(key)}
          variant={view !== key ? 'outlined' : 'contained'}
        >
          {label}
        </Button>
      ))}
    </ButtonGroup>
  );
};
